import React, { useEffect, useState } from 'react';
import classes from './VideoMenu.module.css';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import { convertToRaw, EditorState } from 'draft-js';
import TextEditor from '../../../components/UI/Inputs/TextEditor';
import { htmlToEditorState } from '../../../utils/textEditorUtils';
import { useAppDispatch } from '../../../store/store';
import {
  editConsultationFinding,
  fetchConsultationFindings,
} from '../../../store/slices/consultationFindings';
import draftToHtml from 'draftjs-to-html';

import { useConsultationContext } from '../../../context/ConsultationContext';
import { ContentViewer } from '../../../components/ContentViewer/ContentViewer';
import { useTranslation } from '../../../hooks/useTranslations';
import { toast } from 'react-toastify';
import { CHARACTER_LIMITS, characterLimitMessage } from '../../../utils/characterLimits';

interface Props {
  findingId: number;
  findingText: string;
  isClosed: boolean;
}

const Findings: React.FC<Props> = ({ findingId, findingText, isClosed }) => {
  let isReports = window.location.pathname.includes('reports');
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const { selectedSalesOrder, findingState, setFindingState, addTab } = useConsultationContext();
  const [editFinding, setEditFinding] = useState<boolean>(
    selectedSalesOrder?.consultation_findings?.consultation_findings_description === null
  );

  useEffect(() => {
    dispatch(fetchConsultationFindings());
  }, [dispatch, selectedSalesOrder]);

  const onEditorStateChange = (findingState: EditorState) => {
    setFindingState(findingState);
  };

  const handleSave = async () => {
    if (findingState.getCurrentContent().getPlainText().length > CHARACTER_LIMITS.findings) {
      toast.error(
        characterLimitMessage(translations('error.character_limit'), CHARACTER_LIMITS.findings),
        { position: toast.POSITION.BOTTOM_RIGHT }
      );
      return;
    }

    const result = await dispatch(
      editConsultationFinding({
        consultationsFindingDescription: draftToHtml(
          convertToRaw(findingState?.getCurrentContent())
        ),
        consultationFindingId: findingId,
      })
    );
    if (result.meta.requestStatus === 'fulfilled') {
      setFindingState(EditorState.createEmpty());
      setEditFinding(false);
    }
  };

  const editTab = () => {
    setFindingState(htmlToEditorState(findingText));
    setEditFinding(true);
  };

  const openPreview = () => {
    addTab({ value: 17, text: translations('preview'), isVisible: true });
  };

  return (
    <div style={{ position: 'relative', height: '100%', boxSizing: 'border-box' }}>
      {!selectedSalesOrder?.consultation_findings?.consultation_findings_description &&
      isClosed &&
      isReports ? (
        <div className="emptyState">{translations('label.empty_state')}</div>
      ) : (
        <div className={classes.inputs}>
          {editFinding ? (
            <div>
              <div className={classes.textAreaContainer}>
                {/* <div className={classes.inputLabel}>{translations('abstracts')}</div> */}
                <TextEditor
                  editorState={findingState}
                  onEditorStateChange={onEditorStateChange}
                  readOnly={isClosed}
                />
              </div>
              <div className={classes.btnWrapper}>
                <PrimaryButtonV2
                  text={translations('save')}
                  buttonStyle={{
                    width: '150px',
                    height: '40px',
                  }}
                  disabled={
                    draftToHtml(convertToRaw(findingState?.getCurrentContent())) === '' || isClosed
                  }
                  onClick={handleSave}
                />
                {!isClosed && (
                  <PrimaryButtonV2
                    text={translations('preview')}
                    buttonStyle={{
                      width: '150px',
                      height: '40px',
                      backgroundColor: '#F4F7FD',
                      border: '1px solid #0B1B5C',
                      color: '#0B1B5C',
                    }}
                    onClick={openPreview}
                  />
                )}
              </div>
            </div>
          ) : (
            <div style={{ padding: '10px' }}>
              <ContentViewer
                title={translations('dhpConsultationDetails.findings')}
                content={
                  selectedSalesOrder?.consultation_findings?.consultation_findings_description
                }
                {...(!isClosed ? { editTab: editTab } : {})}
              />
              {!isClosed && (
                <PrimaryButtonV2
                  text={translations('preview')}
                  containerStyle={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: '10px',
                  }}
                  buttonStyle={{
                    width: '150px',
                    height: '40px',
                    backgroundColor: '#F4F7FD',
                    border: '1px solid #0B1B5C',
                    color: '#0B1B5C',
                  }}
                  onClick={openPreview}
                />
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export { Findings };
